import { useContext } from 'react'
import { PassContext } from "../../pass-context"

const styles = {
  appLink: {
    width: 350,
    margin: "auto",
    marginTop: 0,
    marginBottom: 10,
    padding: 10,
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: 10,
  },
  header: {
    fontWeight: 400,
    color: "black",
    marginTop: 5,
  },
  text: {
    color: "#333"
  },
  getButton: {
    backgroundColor: "#ddd",
    borderRadius: 10,
    height: 25,
    width: 60,
    color: "blue",
    fontWeight: 500,
    textAlign: "center",
    padding: 10,
    marginTop: 15,
  }
}

const BackAppLink = () => {

  const { template } = useContext(PassContext)

  if (template.meta.appLink) return (
    <div className="inset">
        <table cellPadding={5} width="100%">
          <tbody>
            <tr>
              <td><img src={template.meta.appLink.icon} /></td>
              <td>
              <div style={styles.header}>{template.meta.appLink.seller}</div>
              <div style={styles.text}>{template.meta.appLink.title}</div>
              </td>
              <td><span style={styles.getButton}>Get</span></td>
            </tr>
          </tbody>
        </table>
    </div>
  )
}

export default BackAppLink